"use strict";

var _classCallCheck = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertExhaustive = exports.assertStruct = exports.assert = exports.AssertionError = void 0;

var superstruct_1 = require("superstruct");
/**
 * Type guard for determining whether the given value is an error object with a
 * `message` property, such as an instance of Error.
 *
 * @param error - The object to check.
 * @returns True or false, depending on the result.
 */


function isErrorWithMessage(error) {
  return typeof error === 'object' && error !== null && 'message' in error;
}
/**
 * Check if a value is a constructor, i.e., a function that can be called with
 * the `new` keyword.
 *
 * @param fn - The value to check.
 * @returns `true` if the value is a constructor, or `false` otherwise.
 */


function isConstructable(fn) {
  var _a, _b;
  /* istanbul ignore next */


  return Boolean(typeof ((_b = (_a = fn === null || fn === void 0 ? void 0 : fn.prototype) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name) === 'string');
}
/**
 * Get the error message from an unknown error object. If the error object has
 * a `message` property, that property is returned. Otherwise, the stringified
 * error object is returned.
 *
 * @param error - The error object to get the message from.
 * @returns The error message.
 */


function getErrorMessage(error) {
  var message = isErrorWithMessage(error) ? error.message : String(error); // If the error ends with a period, remove it, as we'll add our own period.

  if (message.endsWith('.')) {
    return message.slice(0, -1);
  }

  return message;
}
/**
 * Initialise an {@link AssertionErrorConstructor} error.
 *
 * @param ErrorWrapper - The error class to use.
 * @param message - The error message.
 * @returns The error object.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention


function getError(ErrorWrapper, message) {
  if (isConstructable(ErrorWrapper)) {
    return new ErrorWrapper({
      message: message
    });
  }

  return ErrorWrapper({
    message: message
  });
}
/**
 * The default error class that is thrown if an assertion fails.
 */


var AssertionError = /*#__PURE__*/function (_Error) {
  _inherits(AssertionError, _Error);

  var _super = _createSuper(AssertionError);

  function AssertionError(options) {
    var _this;

    _classCallCheck(this, AssertionError);

    _this = _super.call(this, options.message);
    _this.code = 'ERR_ASSERTION';
    return _this;
  }

  return AssertionError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.AssertionError = AssertionError;
/**
 * Same as Node.js assert.
 * If the value is falsy, throws an error, does nothing otherwise.
 *
 * @throws {@link AssertionError} If value is falsy.
 * @param value - The test that should be truthy to pass.
 * @param message - Message to be passed to {@link AssertionError} or an
 * {@link Error} instance to throw.
 * @param ErrorWrapper - The error class to throw if the assertion fails.
 * Defaults to {@link AssertionError}. If a custom error class is provided for
 * the `message` argument, this argument is ignored.
 */

function assert(value) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Assertion failed.';
  var ErrorWrapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : AssertionError;

  if (!value) {
    if (message instanceof Error) {
      throw message;
    }

    throw getError(ErrorWrapper, message);
  }
}

exports.assert = assert;
/**
 * Assert a value against a Superstruct struct.
 *
 * @param value - The value to validate.
 * @param struct - The struct to validate against.
 * @param errorPrefix - A prefix to add to the error message. Defaults to
 * "Assertion failed".
 * @param ErrorWrapper - The error class to throw if the assertion fails.
 * Defaults to {@link AssertionError}.
 * @throws If the value is not valid.
 */

function assertStruct(value, struct) {
  var errorPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Assertion failed';
  var ErrorWrapper = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : AssertionError;

  try {
    (0, superstruct_1.assert)(value, struct);
  } catch (error) {
    throw getError(ErrorWrapper, "".concat(errorPrefix, ": ").concat(getErrorMessage(error), "."));
  }
}

exports.assertStruct = assertStruct;
/**
 * Use in the default case of a switch that you want to be fully exhaustive.
 * Using this function forces the compiler to enforce exhaustivity during
 * compile-time.
 *
 * @example
 * ```
 * const number = 1;
 * switch (number) {
 *   case 0:
 *     ...
 *   case 1:
 *     ...
 *   default:
 *     assertExhaustive(snapPrefix);
 * }
 * ```
 * @param _object - The object on which the switch is being operated.
 */

function assertExhaustive(_object) {
  throw new Error('Invalid branch reached. Should be detected during compilation.');
}

exports.assertExhaustive = assertExhaustive;